import type { SVGProps } from 'react';

const SvgAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M21 12c0-.55-.45-1-1-1V9c.55 0 1-.45 1-1s-.45-1-1-1c0-1.65-1.35-3-3-3 0-.55-.45-1-1-1s-1 .45-1 1h-2c0-.55-.45-1-1-1-.41 0-.76.25-.92.6C10.47 3.23 9.76 3 9 3a4 4 0 0 0-3.74 5.42C3.93 9.07 3 10.43 3 12s.92 2.94 2.26 3.6c-.17.44-.26.92-.26 1.4 0 2.21 1.79 4 4 4 .77 0 1.48-.23 2.08-.6A1.003 1.003 0 0 0 13 20h2c0 .55.45 1 1 1s1-.45 1-1c1.65 0 3-1.35 3-3 .55 0 1-.45 1-1s-.45-1-1-1v-2c.55 0 1-.45 1-1m-8-2h1v4h-1zm-4 9c-1.1 0-2-.9-2-2 0-.66.33-1.28.88-1.65.09.09.17.19.27.26.18.14.4.21.61.21.3 0 .6-.13.79-.39a.99.99 0 0 0-.18-1.4c-.23-.18-.42-.41-.56-.67-.11-.21-.18-.44-.21-.68a.998.998 0 0 0-1.98.24c.03.25.09.5.17.74-.12.08-.23.16-.34.25A2.01 2.01 0 0 1 5 11.99c0-1.1.9-2 2-2 .35 0 .68.09.98.26a1 1 0 0 0 .98-1.74c-.52-.29-1.09-.46-1.69-.5-.18-.31-.28-.66-.28-1.02 0-1.1.9-2 2-2s2 .9 2 2v3.67a.98.98 0 0 0-1.02.18c-.41.37-.44 1-.07 1.41.31.35.68.63 1.09.84v3.89c0 1.1-.9 2-2 2zm9-2c0 .55-.45 1-1 1h-4.14c.08-.32.14-.65.14-1v-1h1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-1V7c0-.35-.06-.68-.14-1H17c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgAi;
